/**
 * Plantillas de correo estandarizadas
 * Estas plantillas se usan tanto en la vista previa como en el envío real
 */

export const emailTemplates = {
  welcome: {
    id: "welcome",
    nombre: "Plantilla de Bienvenida",
    asunto: "Bienvenido a ASSA ABLOY",
    render: (data) => ({
      header: {
        title: "Bienvenido a ASSA ABLOY",
        subtitle: "Abriendo puertas hacia el futuro",
        background: "linear-gradient(135deg, #005fa3 0%, #0077c8 100%)"
      },
      content: {
        greeting: `¡Hola ${data.nombre}!`,
        mainText: "Tu cuenta ha sido creada exitosamente en el sistema.",
        credentialsBox: {
          title: "Credenciales de Acceso",
          fields: [
            { label: "Usuario", value: data.usuario },
            { label: "Contraseña", value: data.password }
          ]
        },
        ctaButton: {
          text: "Iniciar Sesión",
          url: "#"
        }
      }
    })
  },

  birthday: {
    id: "birthday",
    nombre: "Plantilla de Cumpleaños",
    asunto: "¡Feliz Cumpleaños!",
    render: (data) => ({
      header: {
        title: "¡Feliz Cumpleaños!",
        subtitle: "",
        background: "linear-gradient(135deg, #005fa3 0%, #0077c8 100%)"
      },
      content: {
        avatar: data.nombre.charAt(0).toUpperCase(),
        name: data.nombre,
        position: data.cargo,
        mainBox: {
          background: "linear-gradient(135deg, #fff5e6 0%, #ffe4cc 100%)",
          text: `En este día especial, todo el equipo de ASSA ABLOY Colombia te desea un muy feliz cumpleaños.`
        }
      }
    })
  },

  anniversary: {
    id: "anniversary",
    nombre: "Plantilla de Aniversario",
    asunto: "¡Feliz Aniversario!",
    render: (data) => ({
      header: {
        title: "¡Feliz Aniversario!",
        subtitle: `${data.years} Años con Nosotros`,
        background: "linear-gradient(135deg, #005fa3 0%, #0077c8 100%)"
      },
      content: {
        avatar: data.nombre.charAt(0).toUpperCase(),
        name: data.nombre,
        position: data.cargo,
        mainBox: {
          background: "linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)",
          text: `Hoy celebramos ${data.years} años de tu valiosa contribución a ASSA ABLOY Colombia.`
        },
        yearsDisplay: data.years
      }
    })
  }
};

/**
 * Obtiene una plantilla por su ID
 */
export const getTemplate = (templateId) => {
  return emailTemplates[templateId] || null;
};

/**
 * Renderiza una plantilla con datos
 */
export const renderTemplate = (templateId, data) => {
  const template = getTemplate(templateId);
  if (!template) return null;
  return template.render(data);
};
